import { Box, Text } from '@factorialco/deprecated-design-system'
import { ListModuleFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'

import { topModulesByIndustry } from 'modules/upsell/lib/topModulesByIndustry'

import ModuleCard from '../ModuleCard'

type Props = {
  modules: ListModuleFragment[]
}

const PopularModules = ({ modules }: Props) => {
  const current = companies.current
  const industryModules = topModulesByIndustry[current.attributes.industry]

  const filteredChildren = modules.filter((child) => {
    if (!child.chargebeeModuleName) return false
    const modulesArray = child.chargebeeModuleName.split(',')
    return modulesArray.some((module) => industryModules?.includes(module || ''))
  })

  if (!modules.length || !filteredChildren.length) return null

  return (
    <Box paddingBottom="s64" gap="s24">
      <Text weight="medium" size="500" color="grey1000">
        {i18n.t('marketplace.modules.popular_title')}
      </Text>
      <ModuleCard modules={filteredChildren} isPopularModule />
    </Box>
  )
}

export default PopularModules
